/* =============================================================
   AJ - Minimum 3 echantillons : garde-fou au niveau du panier.
   Ajoute 2026-09.

   Desactive le bouton de paiement tant que le panier contient
   1 ou 2 echantillons payants. Les echantillons offerts (propriete
   de ligne _is_sample) et les coffrets Sample Set (non tagues)
   ne sont pas comptes.

   Pour retirer ce correctif : supprimer ce fichier et le bloc
   AJ - minimum 3 echantillons dans snippets/meta-tags.liquid.
   ============================================================= */
(function () {
  var MIN = window.AJ_SAMPLE_MIN || 3;
  var TAG = window.AJ_SAMPLE_TAG || 'sample-product';
  var COLLECTIONS = window.AJ_SAMPLE_COLLECTIONS || ['samples', '2ml'];
  var CACHE_KEY = 'aj_sample_variant_ids_v1';
  var CACHE_TTL = 6 * 60 * 60 * 1000;

  var sampleIds = null;

  function root() {
    var r = window.AJ_ROOT_URL || '/';
    if (r.charAt(r.length - 1) !== '/') r += '/';
    return r;
  }

  function samplesUrl() {
    return root() + 'pages/choose-your-samples';
  }

  function isFrench() {
    var l = (document.documentElement.getAttribute('lang') || '').toLowerCase();
    return l.indexOf('fr') === 0;
  }

  function message(missing) {
    if (isFrench()) {
      return 'Les échantillons se commandent par 3 minimum. Ajoutez-en encore ' + missing + ', ou retirez-les du panier.';
    }
    return 'Samples are sold in sets of 3 minimum. Add ' + missing + ' more, or remove them from your cart.';
  }

  function linkLabel() {
    return isFrench() ? 'Choisir mes échantillons' : 'Choose my samples';
  }

  /* ---------- 1. Liste des variantes echantillon ---------- */

  function readCache() {
    try {
      var raw = sessionStorage.getItem(CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.t || Date.now() - parsed.t > CACHE_TTL) return null;
      if (!Array.isArray(parsed.ids)) return null;
      return parsed.ids;
    } catch (e) {
      return null;
    }
  }

  function writeCache(ids) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), ids: ids }));
    } catch (e) {}
  }

  function loadSampleIds() {
    var cached = readCache();
    if (cached) {
      sampleIds = cached;
      return Promise.resolve(cached);
    }

    var requests = COLLECTIONS.map(function (handle) {
      return fetch(root() + 'collections/' + handle + '/products.json?limit=250', {
        headers: { Accept: 'application/json' }
      })
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .catch(function () { return { products: [] }; });
    });

    return Promise.all(requests).then(function (results) {
      var ids = {};
      results.forEach(function (res) {
        (res.products || []).forEach(function (p) {
          var tags = p.tags || [];
          if (tags.indexOf(TAG) === -1) return;
          (p.variants || []).forEach(function (v) { ids[String(v.id)] = true; });
        });
      });
      sampleIds = Object.keys(ids);
      if (sampleIds.length) writeCache(sampleIds);
      return sampleIds;
    });
  }

  /* ---------- 2. Application du blocage ---------- */

  function checkoutButtons() {
    return [].slice.call(
      document.querySelectorAll('[name="checkout"], #checkout, .cart__checkout-button')
    );
  }

  function expressBlocks() {
    return [].slice.call(
      document.querySelectorAll('#dynamic-checkout-cart, .cart__dynamic-checkout-buttons')
    );
  }

  function buildNotice() {
    var el = document.createElement('div');
    el.className = 'aj-sample-min-notice';
    el.setAttribute('role', 'alert');
    el.style.cssText =
      'margin:1rem 0;padding:1rem 1.2rem;border:1px solid #d9534f;color:#d9534f;font-size:1.4rem;line-height:1.4;';

    var text = document.createElement('span');
    text.className = 'aj-sample-min-text';
    el.appendChild(text);
    el.appendChild(document.createElement('br'));

    var link = document.createElement('a');
    link.className = 'aj-sample-min-link';
    link.style.cssText = 'display:inline-block;margin-top:.6rem;color:inherit;text-decoration:underline;';
    link.href = samplesUrl();
    link.textContent = linkLabel();
    el.appendChild(link);

    return el;
  }

  function apply(count) {
    var blocked = count > 0 && count < MIN;
    var buttons = checkoutButtons();

    buttons.forEach(function (b) {
      if (blocked) {
        b.setAttribute('disabled', 'disabled');
        b.setAttribute('data-aj-blocked', 'true');
        b.style.opacity = '0.5';
        b.style.pointerEvents = 'none';
      } else if (b.getAttribute('data-aj-blocked') === 'true') {
        b.removeAttribute('disabled');
        b.removeAttribute('data-aj-blocked');
        b.style.opacity = '';
        b.style.pointerEvents = '';
      }
    });

    expressBlocks().forEach(function (d) {
      if (blocked) {
        d.setAttribute('data-aj-blocked', 'true');
        d.style.display = 'none';
      } else if (d.getAttribute('data-aj-blocked') === 'true') {
        d.removeAttribute('data-aj-blocked');
        d.style.display = '';
      }
    });

    var notices = [].slice.call(document.querySelectorAll('.aj-sample-min-notice'));

    if (!blocked) {
      notices.forEach(function (n) { n.parentNode && n.parentNode.removeChild(n); });
      return;
    }

    var missing = MIN - count;

    buttons.forEach(function (b) {
      var host = (b.closest && b.closest('.cart__ctas')) || b.parentNode;
      if (!host) return;
      var existing = host.querySelector('.aj-sample-min-notice');
      if (!existing) {
        existing = buildNotice();
        host.insertBefore(existing, host.firstChild);
      }
      existing.querySelector('.aj-sample-min-text').textContent = message(missing);
    });
  }

  /* ---------- 3. Lecture du panier ---------- */

  var busy = false;
  var queued = false;

  function check() {
    if (!sampleIds || !sampleIds.length) return;
    if (busy) { queued = true; return; }
    busy = true;

    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = 0;
        (cart.items || []).forEach(function (item) {
          var props = item.properties || {};
          if (props._is_sample) return;
          if (sampleIds.indexOf(String(item.variant_id)) !== -1) count += item.quantity;
        });
        apply(count);
      })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (queued) { queued = false; setTimeout(check, 200); }
      });
  }

  var debounceTimer;
  function scheduleCheck() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(check, 250);
  }

  function boot() {
    loadSampleIds().then(function () {
      check();

      document.addEventListener('cart:updated', scheduleCheck);
      document.addEventListener('cart:refresh', scheduleCheck);

      if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate) {
        try { window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, scheduleCheck); } catch (e) {}
      }

      if (window.MutationObserver) {
        var observer = new MutationObserver(scheduleCheck);
        var targets = document.querySelectorAll('cart-drawer, cart-items, #main-cart-footer, .cart__footer');
        [].slice.call(targets).forEach(function (t) {
          observer.observe(t, { childList: true, subtree: true });
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
